import React from "react";
import { Link } from "react-router-dom";
import { Layers, Code2, Sparkles, ArrowRight, CheckCircle2 } from "lucide-react";
import { PageHero } from "./Universita";

export default function DoppiaLaurea() {
  return (
    <div data-testid="page-doppia-laurea">
      <PageHero
        eyebrow="Doppia Laurea & Alta Formazione"
        title="Due titoli. Meno tempo. Più valore."
        sub="Il programma Doppia Laurea ti permette di conseguire due titoli accademici risparmiando tempo grazie al riconoscimento degli esami in comune."
      />

      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="eyebrow text-brand-emerald mb-3">Come funziona</div>
            <h2 className="font-heading font-extrabold text-3xl sm:text-4xl text-brand-navy leading-tight">
              Un percorso, due lauree riconosciute MIUR.
            </h2>
            <p className="mt-5 text-brand-muted text-lg leading-relaxed">
              Il programma Doppia Laurea consente di iscriversi a due corsi di laurea contemporaneamente. Le università telematiche convenzionate riconoscono gli esami in comune, riducendo significativamente il numero di esami da sostenere.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              {[
                { title: "2 titoli accademici", desc: "Doppio diploma di laurea spendibile in concorsi e mercato del lavoro." },
                { title: "Risparmio tempo", desc: "Fino al 40% di esami in meno grazie ai riconoscimenti incrociati." },
                { title: "Risparmio costi", desc: "Convenzioni dedicate e rate agevolate sul programma doppio." },
                { title: "CV internazionale", desc: "Combinazione di competenze altamente richiesta dalle aziende." },
              ].map((v) => (
                <div key={v.title} className="rounded-2xl bg-brand-surface border border-brand-line p-5">
                  <CheckCircle2 className="w-5 h-5 text-brand-emerald mb-2" />
                  <div className="font-heading font-bold text-brand-navy">{v.title}</div>
                  <div className="text-sm text-brand-muted mt-1">{v.desc}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-3xl overflow-hidden border border-brand-line bg-brand-surface p-8 sticky top-28">
              <Layers className="w-10 h-10 text-brand-emerald" />
              <h3 className="font-heading font-extrabold text-2xl text-brand-navy mt-4">Combinazioni più richieste</h3>
              <ul className="mt-5 space-y-3 text-sm">
                {[
                  "Economia Aziendale + Giurisprudenza",
                  "Psicologia + Scienze dell'Educazione",
                  "Ingegneria Informatica + Economia",
                  "Scienze della Nutrizione + Scienze Motorie",
                  "Scienze della Comunicazione + Marketing",
                ].map((c) => (
                  <li key={c} className="flex gap-2 text-brand-ink">
                    <ArrowRight className="w-4 h-4 text-brand-emerald shrink-0 mt-0.5" /> {c}
                  </li>
                ))}
              </ul>
              <Link to="/contatti" className="btn-primary w-full justify-center mt-7" data-testid="doppia-cta">
                Richiedi una combinazione personalizzata
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-24 bg-brand-surface">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-6">
            <div className="rounded-3xl bg-brand-navy text-white p-8 lg:p-10 relative overflow-hidden" data-testid="alta-formazione-perfez">
              <div className="absolute inset-0 dot-pattern opacity-[0.06]" />
              <div className="relative">
                <Sparkles className="w-10 h-10 text-brand-emerald" />
                <h3 className="font-heading font-extrabold text-2xl mt-4">Corsi di Perfezionamento</h3>
                <p className="text-white/80 mt-3 leading-relaxed">
                  Aggiornamento professionale 1500h, validi per graduatorie e concorsi pubblici. Su misura per docenti, professionisti e dipendenti pubblici.
                </p>
                <Link to="/contatti" className="btn-ghost-white mt-6" data-testid="perfez-cta">Scopri di più <ArrowRight className="w-4 h-4" /></Link>
              </div>
            </div>

            <div className="rounded-3xl bg-white border border-brand-line p-8 lg:p-10" data-testid="alta-formazione-aulab">
              <Code2 className="w-10 h-10 text-brand-emerald" />
              <h3 className="font-heading font-extrabold text-2xl text-brand-navy mt-4">Corsi Digital & Tech (Aulab)</h3>
              <p className="text-brand-muted mt-3 leading-relaxed">
                Coding bootcamp, Web Development e Data Analytics in partnership con Aulab. Percorsi intensivi con sbocco lavorativo diretto.
              </p>
              <Link to="/contatti" className="btn-secondary mt-6" data-testid="aulab-cta">Scopri Aulab <ArrowRight className="w-4 h-4" /></Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
